export const environment = {
  appVersion: "v" + require('../../package.json').version,
  clientId: require('../../package.json').clientId,
  production: true
};
